module.exports = __webpack_public_path__ + "img/terroir-wavy-4-mobile.67e04b6a.jpg";